<template>
    <div class="pl-column-edit-item" @click="handleClick">
        <keep-alive>
            <link-textarea-input
                    v-if="lv_editable"
                    v-model="showRow[field]"

                    :required="lv_required"
                    :rules="rules"
                    :validate-on-init="validateOnInit"
					:maxlength="maxlength"
					:showWordLimit="showWordLimit"
            />
            <template v-else>
                <link-table-cell-normal
                        :render-func="renderFunc"
                        :scope-slot-func="scopeSlotFunc"
                        :text="showRow[field]"
                        :data="scopeSlotData"/>
            </template>
        </keep-alive>
    </div>
</template>

<script>
    import {ColumnItemMixin} from "../mixins";

    export default {
        name: "link-table-column-textarea-item",
        mixins: [ColumnItemMixin],
		props: {
			maxlength: Number,
			showWordLimit: Boolean,
		}
    }
</script>

<style lang="scss">

</style>
